import { Component, ViewChild, OnInit } from '@angular/core';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Globals } from 'app/_globals';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { NotificationService } from 'app/_services/notification.service';
import { environment } from '../../environments/environment';
import { DynamicFormComponent } from '../_dynamic_form/containers/dynamic_form/dynamic-form.component';
import { ConsoleUserService } from '../_services/console-user.service';
import { CookieService } from 'ngx-cookie-service';

@Component({
    selector: 'app-u-console-users',
    templateUrl: './u-console-users.component.html',
    styleUrls: ['./u-console-users.component.css']
})
export class UConsoleUsersComponent implements OnInit {

    @ViewChild(DynamicFormComponent) filterForm: DynamicFormComponent;

    users: any[] = [];
    selectedUser: any;

    storeId: any;

    sidebarVisible = false;
    createUserModal = false;
    createUserForm: FormGroup;
    editUserForm: FormGroup;

    pageSizes: any = environment.pageSizes;
    pagination: any;

    selectedSort: any;

    sortFields: any[] = [
        {
            sortName: 'First Name (asc)',
            sortString: 'firstName,asc'
        },
        {
            sortName: 'First Name (desc)',
            sortString: 'firstName,desc'
        },
        {
            sortName: 'Last Name (asc)',
            sortString: 'lastName,asc'
        },
        {
            sortName: 'Last Name (desc)',
            sortString: 'lastName,desc'
        }
    ];

    userTypes: any[] = [
        {label: 'Store', value: 'STORE'},
        {label: 'Group', value: 'GROUP'},
        {label: 'Delivery', value: 'DELIVERY'}
    ];
    selectedUserType: any = this.userTypes[0];

    role: any;
    routeRole: any;
    cookieStore: any;

    editUserModal = false;
    userPinModal = false;

    constructor(
        public loader: LoadingBarService,
        public activatedRoute: ActivatedRoute,
        public router: Router,
        public globals: Globals,
        public fb: FormBuilder,
        public notificationService: NotificationService,
        public _consoleUserService: ConsoleUserService,
        public cookieService: CookieService
    ) {

        const hasCurrentStore = cookieService.check('currentStore');
        if (hasCurrentStore) {
            this.cookieStore = JSON.parse(cookieService.get('currentStore'));
            this.storeId = this.cookieStore.id;
        } else {
            this.router.navigate(['/' + this.globals.user.routeRole + '/select-store']);
        }

        this.role = globals.user.role;
        this.routeRole = globals.user.routeRole;

        this.createUserForm = fb.group({
            firstName: new FormControl(''),
            lastName: new FormControl(''),
            email: new FormControl(''),
            type: new FormControl(''),
            manage: new FormControl(false)
        });

        this.editUserForm = fb.group({
            firstName: new FormControl(''),
            lastName: new FormControl(''),
            email: new FormControl(''),
            type: new FormControl(''),
            manage: new FormControl()
        })

        this.selectedSort = this.sortFields[0];
        this.resetPagination();
    }

    ngOnInit() {
        this.getAllConsoleUsers();
    }

    // Get all console users based on store
    public getAllConsoleUsers() {
        this._consoleUserService.getConsoleUsersByStore(this.storeId)
            .subscribe((data: any) => {
                this.users = data;
                console.log(data);
            })
    }


    /* PAGINATION */
    public resetPagination() {
        this.pagination = {
            size: this.pageSizes[0],
            page: 0,
            totalRecords: 0
        }
    }

    paginate(event) {
        console.log(event);
        this.pagination.size = event.rows;
        this.pagination.page = event.page;
    }
    /* PAGINATION END */

    // toggle the create user modal
    public toggleCreateUserModal() {
        this.createUserModal = !this.createUserModal;
    }

    // user type onChange event
    public onSelectedUserTypeChange(event) {
        console.log(event);
        this.selectedUserType = event;
    }

    // create user, reset forms, toggle modal, reload data
    public onCreateUserFormSubmit() {
        const values = this.createUserForm.value;
        const body = {
            email: values.email,
            firstName: values.firstName,
            lastName: values.lastName,
            login: values.email,
            organisation: this.globals.user.organisation,
            storeId: this.storeId,
            type: this.selectedUserType.value,
            manager: values.manage
        };
        this._consoleUserService.createConsoleuser(body)
            .subscribe((data: any) => {
                console.log(data);
                this.toggleCreateUserModal();
                this.createUserForm.reset();
                this.resetPagination();
                this.getAllConsoleUsers();
                this.notificationService.notify(
                    'success',
                    'Console User Created',
                    'Console User has been sucessfully created',
                    'top',
                    'right');
            })
    }

    // Handle sort change and reload data
    // TO DO
    sortChange(event) {
        this.selectedSort = event;
        this.resetPagination();
    }

    // In table action buttons
    // view console user password
    public viewPassword(user) {
        this.selectedUser = user;
        this.toggleUserPinModal();
    }

    public toggleUserPinModal() {
        this.userPinModal = !this.userPinModal;
    }

    // edit console user button
    public selectUserForEdit(user) {
        this.selectedUser = user;
        this.populateEditUserForm();
        this.toggleEditUserModal();
    }

    public populateEditUserForm() {
        this.editUserForm.patchValue({
            firstName: this.selectedUser.firstName,
            lastName: this.selectedUser.lastName,
            email: this.selectedUser.email,
            type: this.selectedUser.consoleUser.type,
            manage: this.selectedUser.consoleUser.manager
        })
        if (this.selectedUser.consoleUser.manager === null) {
            this.editUserForm.patchValue({
                manage: false
            })
        }
    }

    public toggleEditUserModal() {
        this.editUserModal = !this.editUserModal;
    }

    public onEditUserFormSubmit() {
        const values = this.editUserForm.value;
        const body = {
            email: values.email,
            firstName: values.firstName,
            lastName: values.lastName,
            login: values.email,
            organisation: this.globals.user.organisation,
            storeId: this.storeId,
            type: this.selectedUserType.value,
            bludotUserId: this.selectedUser.id,
            manager: values.manage,
        };

        this._consoleUserService.editConsoleUser(body)
            .subscribe((data: any) => {
                console.log(data);
                this.toggleEditUserModal();
                this.editUserForm.reset();
                this.resetPagination();
                this.getAllConsoleUsers();
                this.notificationService.notify(
                    'success',
                    'Console User Edited',
                    'Console User has been sucessfully edited',
                    'top',
                    'right');
            })
    }

}



// WEBPACK FOOTER //
// ./src/app/u-console-users/u-console-users.component.ts